import { electricityConsumptionInputsUK } from './regions/UK-electricity-consumption.input'
import { electricityConsumptionInputsUS } from './regions/US-electricity-consumption.input'

export const electricityConsumptionMapping: { [key: string]: any } = {
  US: electricityConsumptionInputsUS,
  UK: electricityConsumptionInputsUK,
}
